import { individualMeterKeys } from '../../config/import/settingStepFieldKeys';
import { createFlatKey } from '../addresses';

const flatNotExistMsg = 'Отсутствует данное помещение';

const checkIsFlatExist = ({ data, typeId, name }) => {
  const flatKey = createFlatKey({ typeId, name });
  return Boolean(data[flatKey]);
};

const getProcessMeter =
  ({ flatsByTypeAndName, valid, invalid }) =>
  (meter) => {
    const {
      [individualMeterKeys.addressType]: addressTypeId,
      [individualMeterKeys.flat]: addressName,
    } = meter;

    const isFlatExist = checkIsFlatExist({
      data: flatsByTypeAndName,
      typeId: addressTypeId,
      name: addressName,
    });

    isFlatExist
      ? valid.push(meter)
      : invalid.push({ ...meter, errors: flatNotExistMsg });
  };

export const checkMeters = ({ validationResult, data }) => {
  const valid = [];
  const invalid = validationResult.invalid.slice();

  const processMeter = getProcessMeter({ ...data, valid, invalid });

  validationResult.valid.forEach(processMeter);

  return { valid, invalid };
};
